import { jsx } from 'react/jsx-runtime';

var DefaultIcon = function DefaultIcon() {
  return /*#__PURE__*/jsx("svg", {
    "aria-hidden": true,
    fill: "none",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    children: /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2 11.996C2 6.476 6.475 2 11.996 2c5.52 0 9.996 4.476 9.996 9.996 0 5.52-4.476 9.995-9.996 9.995C6.475 21.991 2 17.516 2 11.996ZM10.74 7a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm.25 3v8h2v-8h-2Z",
      clipRule: "evenodd"
    })
  });
};

export { DefaultIcon as default };
//# sourceMappingURL=DefaultIcon.js.map
